import { RouteObject } from 'react-router-dom';
import { ServiceHistory } from '../ServiceHistory';
import { CreateServiceHistory } from '../pages';
import { Authorize } from '@/components';
import { ROLES } from '@/components/security/AppRoles';
import { ErrorPage } from '@/pages/Layout/pages';

const ServiceHistoryRoutes: RouteObject[] = [
  {
    path: 'service-history',
    element: <ServiceHistory />,
  },
  {
    path: 'service-history/create',
    element: (
      <Authorize
        permission={ROLES.INVENTORY.admin}
        fallback={<ErrorPage code={403} />}
      >
        <CreateServiceHistory />
      </Authorize>
    ),
  },
];

export default ServiceHistoryRoutes;
